import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {AsyncPipe, NgStyle} from '@angular/common';
import {FileUploadModule} from 'primeng/fileupload';
import {ConfirmationService, LazyLoadEvent, MessageService, SharedModule} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from 'primeng/dynamicdialog';
import {AuthService} from '../service/auth.service';
import {ImportsFilter, ImportsService} from '../service/imports.service';
import {Import} from '../models/import.model';

@Component({
    selector: 'app-imports',
    imports: [
        ConfirmDialogModule,
        AsyncPipe,
        FileUploadModule,
        SharedModule,
        TableModule,
        TranslateModule,
        NgStyle
    ],
    templateUrl: './imports.component.html',
    styleUrl: './imports.component.scss'
})
export class ImportsComponent  implements OnInit {

  private items: BehaviorSubject<Import[]> = new BehaviorSubject([]);
  private count: BehaviorSubject<number> = new BehaviorSubject(0);
  private pending: BehaviorSubject<boolean> = new BehaviorSubject(false);

  items$: Observable<Import[]> = this.items.asObservable();
  count$: Observable<number> = this.count.asObservable();
  pending$: Observable<boolean> = this.pending.asObservable();
  empty$: Observable<boolean> = this.count$.pipe(map(count => count === 0));
  filter: ImportsFilter = new ImportsFilter(0, 10, '-id');

  loading = false;
  id: string;
  label: string;

  imports: Import[];
  COMPLETED = 'COMPLETED';

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    public dialogService: DialogService,
    private importsService: ImportsService,
    public auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.fetchImports();
  }

  fetchImports(): void {
    this.loading = true;
    this.importsService.find(this.filter).subscribe(data => {
      this.pending.next(false);
      this.items.next(data.values);
      this.count.next(data.count);
      this.imports = data.values;
      this.loading = false;
    }, error => {
      console.log(error);
    });
  }

  pageChanged(event: LazyLoadEvent): void {
    this.filter.limit = event.rows;
    this.filter.offset = event.first;
    this.filter.search = event.globalFilter;
    if (event.sortOrder === -1) {
      this.filter.orderBy = '-' + event.sortField;
    } else {
      this.filter.orderBy = event.sortField;
    }
    this.fetchImports();
  }

  viewImport(id): void {
    this.router.navigate(['imports/' + id]);
  }

  onUploadAttachment(): void {
    this.fetchImports();
  }
}
